import { SxProps } from '@mui/material/styles'

export const getEditableFieldInputStyles = (isEditing?: boolean, hasError?: boolean): SxProps => {
  if (hasError) {
    return {}
  }

  if (isEditing) {
    return {
      '&:hover': {
        cursor: 'text',
      },
    }
  }

  return {
    '& fieldset': { border: 'none' },
    '&:hover fieldset': { borderWidth: '1px', borderColor: 'neutralLight.300', borderStyle: 'solid' },
  }
}
